import { SetDefaultData, FetchOrganizationRequest, UpdateField, UpdateOrganizationRequest } from '../organizations.actions';
import { getUpdateOrganizationState } from '../organizations.selectors';
import Validator from '@shared/validatorjs/src/validator';
import { ActivatedRoute } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Component, OnInit } from '@angular/core';
import FormTrait from 'src/app/traits/form.trait';
import { Subscription } from 'rxjs';
import { Map } from 'immutable';

@Component({
  selector: 'app-update-organization',
  templateUrl: './update-organization.component.html',
  styleUrls: ['./update-organization.component.css']
})
export class UpdateOrganizationComponent extends FormTrait implements OnInit {

  private state$: Subscription;
  public isLoading: boolean;
  public userId: number;

  constructor(public store: Store<any>, private route: ActivatedRoute) {
    super()
  }

  ngOnInit() {
    this.userId = parseInt(this.route.snapshot.paramMap.get("id"))
    this.store.dispatch<any>(new SetDefaultData('updateOrganization'))
    this.state$ = this.store.pipe(select(getUpdateOrganizationState)).subscribe(state => {
      this.state = state;
      this.isLoading = state.get('isLoading')
    });

    this.store.dispatch<any>(new FetchOrganizationRequest(this.userId))
  }

  public handleFieldChange(e: any, name: null | string = null): void {

    this.store.dispatch(
      new UpdateField(name || e.target.name, name ? e : e.target.value, 'updateOrganization.data')
    );

    this.store.dispatch(
      new UpdateField('validationErrors', this.state
        .get('validationErrors')
        .delete(name || e.target.name), 'updateOrganization')
    );
  }

  validation() {
    const data = this.state.get('data');
    const rules = {
      name: "required"
    };
    const validator = new Validator(
      {
        name: data.get('name')
      },
      rules,
    );

    return validator;
  }

  public onSubmit(e: Event): void {

    e.preventDefault();

    const validation = this.validation();
    const payload = this.state.get('data').toJS();

    if (validation.passes()) {
      this.store.dispatch(new UpdateOrganizationRequest(this.userId, payload));
    } else {
      this.store.dispatch<any>(
        new UpdateField('validationErrors', validation.errors.errors, 'updateOrganization')
      );
    }
  }

}
